import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { STORE_LINKS } from '../site.config';

/// Resmî rozetler (Apple/Google yönergeleri: değiştirilmeden, yeterli boşlukla).
/// Google görselinde üst/alt ~%12 saydam pay var (646×250, görünen 192 px): 52 px yükseklik +
/// -6 px dikey pay ile görünen yükseklik App Store'unkiyle aynı 40 px olur.
@Component({
  selector: 'site-store-badges',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <ul role="list" class="flex flex-wrap items-center gap-x-3 gap-y-2">
      <li>
        <a [href]="links.appStore" class="inline-flex min-h-tap items-center" data-test="badge-app-store">
          <img
            src="assets/site/badges/app-store-tr.svg"
            alt="App Store'dan indirin"
            width="151"
            height="40"
            [attr.loading]="eager() ? 'eager' : 'lazy'"
          />
        </a>
      </li>
      <li>
        <a [href]="links.googlePlay" class="inline-flex min-h-tap items-center" data-test="badge-google-play">
          <img
            src="assets/site/badges/google-play-tr.webp"
            alt="Google Play'den alın"
            width="134"
            height="52"
            class="-my-1.5"
            [attr.loading]="eager() ? 'eager' : 'lazy'"
          />
        </a>
      </li>
    </ul>
  `,
})
export class StoreBadgesComponent {
  readonly eager = input(false);
  readonly links = STORE_LINKS;
}
